<script lang="ts">
  // Same serif-accent face + preload as pages/home — see that css file for
  // the font-display: optional rationale. The italic face replaces the old
  // upright import: `.serif-accent em` (plans.svelte) is the only consumer
  // of Instrument Serif, so pages here used to synthesize a faux italic.
  import serifItalicUrl from "@fontsource/instrument-serif/files/instrument-serif-latin-400-italic.woff2?url"
  import "@/styles/instrument-serif-italic.css"
  import { page } from "@inertiajs/svelte"
  import type { Snippet } from "svelte"

  import MarketingFooter from "@/components/marketing-footer.svelte"
  import MarketingHeader from "@/components/marketing-header.svelte"

  // The public ("logged-out") manager chrome: full-height background, top
  // radial glow, header, and footer. Used as an Inertia persistent layout by
  // the public pages (pricing, billing plans) and — via
  // marketing-page-layout.svelte — the legal/imprint/contact prose pages.
  // Pages supply their own <main>.
  type Props = { children?: Snippet }
  const { children }: Props = $props()

  // Signed-in state is read from the globally-shared `auth` prop
  // (InertiaController#inertia_share), so pages don't thread it through.
  const auth = $derived(page.props.auth as { user?: unknown } | undefined)
  const signedIn = $derived(auth?.user != null)
</script>

<svelte:head>
  <link
    rel="preload"
    href={serifItalicUrl}
    as="font"
    type="font/woff2"
    crossorigin="anonymous"
  />
</svelte:head>

<div
  class="relative min-h-screen overflow-hidden bg-[#FDFDFC] text-[#1b1b18] dark:bg-[#0a0a0a] dark:text-[#EDEDEC]"
>
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[900px] bg-[radial-gradient(ellipse_60%_60%_at_50%_0%,#E5EEFA_0%,transparent_70%)] dark:bg-[radial-gradient(ellipse_60%_60%_at_50%_0%,#0f1825_0%,transparent_70%)]"
  ></div>

  <MarketingHeader signed_in={signedIn} />

  {@render children?.()}

  <MarketingFooter />
</div>
